import React from 'react';
import { useDispatch } from "react-redux";
import { articleChanged, titleChanged } from '../redux/filtersBlogs/actions';

const BlogCart = ({ dt }) => {
    const { id, img, catagory, title, author, author_url, date, readTime } = dt;
    const dispatch = useDispatch()

    const handleArticleChagned = (article) => {
        dispatch(articleChanged(article))
    }

    const handleTitleChange = (title) => {
        dispatch(titleChanged(title))
    }

    return (
        <div
            class="flex flex-col rounded-lg shadow-lg overflow-hidden"
        >
            <div class="flex-shrink-0">
                <img
                    class="h-48 w-full object-cover"
                    src={img}
                    alt=""
                />
            </div>

            <div
                class="flex-1 bg-white p-6 flex flex-col justify-between"
            >
                <div class="flex-1">
                    <p class="text-sm font-medium text-indigo-600" >

                        <span onClick={() => handleArticleChagned(catagory)}
                            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"
                        >
                            {catagory}

                        </span>
                    </p>
                    <p
                        class="text-xl font-semibold text-gray-900"
                       
                    >
                        {title}

                    </p>
                </div>
                <div class="mt-6 flex items-center">
                    <div class="flex-shrink-0">
                        <img
                            class="h-10 w-10 rounded-full"
                            src={author_url}
                            alt=""
                        />
                    </div>
                    <div class="ml-3">
                        <p
                            class="text-sm font-medium text-gray-900 hover:underline"
                            onClick={() => handleTitleChange(author)}
                        >
                            {author}
                        </p>
                        <div
                            class="flex space-x-1 text-sm text-gray-500"
                        >
                            <time datetime="2020-03-16"
                            >{date}
                            </time>
                            <span aria-hidden="true">
                                &middot;
                            </span>
                            <span>{readTime}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCart;